export default "__VITE_ASSET__BC7RJNCD__"